import styled from '@emotion/styled';
import { CasinoLoaderContainer } from 'src/domains/layouts/shared/loaders';
import { withConfig } from 'src/withConfig';

export const CasinoNavigationWrapper = withConfig(theme => styled('div', { label: 'CasinoNavigationWrapper' })`
    align-items: center;
    background: ${theme.star.casino.bgColor};
    display: flex;
    gap: ${theme.star.gap.medium};
    height: 76px;
    justify-content: star;
    overflow: hidden;
    padding: 16px 0 16px 16px;
    position: sticky;
    z-index: ${theme.star.zIndexGlobal.above};
    @media ${theme.star.mediaQuery.desktop} {
        top: 0;
        padding-left: 24px;
    }
`);

export const SearchbarLoader = withConfig(theme => styled(CasinoLoaderContainer, { label: 'SearchbarLoader' })`
    background-color: ${theme.star.skeletonLoader.placeholder.bgColorDenary};
    flex: 0 0 44px;
    height: 44px;
    margin-right: 8px;
    width: 44px;
    @media ${theme.star.mediaQuery.desktop} {
        padding-left: 24px;
    }
`);

export const CategoryLoader = withConfig(theme => styled(CasinoLoaderContainer, { label: 'CategoryLoader' })`
    height: 32px;
    width: 96px;
    background-color: ${theme.star.skeletonLoader.placeholder.bgColorDenary};
`);
